module.exports = __webpack_public_path__ + "img/new-home-page-guide-drawer-illustration-fr5.5369d7b.png";